import { effect, stop } from '@vue/reactivity'
import { evaluateInScope } from '../component/utils'

export default {

    signature: 'qv-html',

    handle(node, scope) {

        if (node.nodeType !== Node.ELEMENT_NODE) {
            return null
        }

        if (!node.hasAttribute(this.signature)) {
            return null
        }

        const runner = effect(() => {
            node.innerHTML = evaluateInScope(node.getAttribute(this.signature), scope)
        })

        return () => {
            stop(runner)
        }

    },

}
